import { useEffect, useState } from 'react';
import { init as initHeap, identifyOrganization as heapIdentifyOrganization } from '../heap-analytics';
import useOrganizationName from '@/modules/my-account/hooks/useOrganizationName';

export function useAnalytics(): void {
  const [isHeapInitialized, setIsHeapInitialized] = useState(false);

  const organizationName = useOrganizationName();

  useEffect(() => {
    if (isHeapInitialized && organizationName) {
      heapIdentifyOrganization(organizationName);
    }
  }, [organizationName, isHeapInitialized]);

  if (!isHeapInitialized) {
    initHeap();
    setIsHeapInitialized(true);
  }
}
